import React from 'react';

import SessionService from '../../../services/session.service';
import { API_HOST } from '../../../constants/server.constant';
import { axiosRequestWithAuth } from './../../../constants/server.constant';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';
import $ from 'jquery';



class BmrSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bmrList: this.props.bmrList
        };
        this.gotoCreateBM = this.gotoCreateBM.bind(this);
    }

    componentDidMount() {

    }
    componentWillReceiveProps(nextProps) {
        this.setState({ bmrList: nextProps.bmrList });
    }

    closeSlider = () => {
        $(".bmr_notify_slider").removeClass("active");
        $("body").removeClass("popup_no_scroll");
    };
    gotoCreateBM = (event, bmr) => {
        this.props.history.push({
            pathname: "/create",
            state: {
                bmr: { ...bmr },
                regionName: bmr.region.region_id
            }
        });
    };
    render() {
        return (
            <div>
                <div className="main_slider bmr_notify_slider">
                    <div className="slider_bg_shadow"></div>
                    <div className="slider_wrapper">
                        <div className="main_slider_container">
                            <div className="close_icon" onClick={ () => this.closeSlider() }></div>
                            <div className="bmrNotifySlide_wrap">
                                <div className="head_block">
                                    <h2>Bare Metal Status</h2>
                                </div>
                                <div className="bmrNotify_content_wrap">
                                    {
                                        this.state.bmrList.map((bmr, index) =>
                                            <div className="bmrNotify_blck" key={ index }>
                                                <div className="NotifyInfo">
                                                    <ul>
                                                        <li style={ { display: "none" } }>
                                                            <div className="slct-lhs">Name</div>
                                                            <div className="slct-rhs">Bare Metal1</div>
                                                        </li>
                                                        <li>
                                                            <div className="slct-lhs">Region</div>
                                                            <div className="slct-rhs">{ bmr.region.name }({ bmr.region.region_id })</div>
                                                        </li>
                                                        <li>
                                                            <div className="slct-lhs">Plan</div>
                                                            <div className="slct-rhs"><span><b>{ bmr.flavour.processor }</b> Processor</span> <b>{ bmr.flavour.vcpus }</b> cores / <b>{ bmr.flavour.threads }</b> threads, { bmr.flavour.disk < 1024 ? bmr.flavour.disk + " GB " : (Math.round((bmr.flavour.disk / 1024) * 1000) / 1000) + " TB " } { bmr.flavour.disk_type } Storage, { bmr.flavour.ram / 1024 }GB RAM</div>
                                                        </li>
                                                        <li>
                                                            <div className="slct-lhs">Units</div>
                                                            <div className="slct-rhs">{ bmr.bmrUnits }</div>
                                                        </li>

                                                        <li>
                                                            <div className="slct-lhs">Date</div>
                                                            <div className="slct-rhs">{ bmr.bm_requested_on }</div>
                                                        </li>

                                                    </ul>
                                                    <p className="note pendingMsg" style={ { display: bmr.bmrStatus == "pending" ? "" : "none" } }>Your request for bare-metal instance provisioning is being processed. For more details <a href="https://www.idrivecompute.com/support.htm" target="_blank">contact support</a>.</p>
                                                    <p className="note availableMsg" style={ { display: bmr.bmrStatus == "available" ? "" : "none" } }>Your bare-metal instance has been provisioned on { bmr.provisionedDate }.</p>
                                                    <p className="note canceledMsg" style={ { display: bmr.bmrStatus == "canceled" ? "" : "none" } }>Your request for bare-metal instance is canceled. For more details <a href="https://www.idrivecompute.com/support.htm" target="_blank">contact support</a>.</p>
                                                    <input type={ bmr.bmrStatus == "available" ? "button" : "hidden" } name="" value="Create Now" className="common_cta_btn blue createNow_Btn" onClick={ (e) => this.gotoCreateBM(e, bmr) } />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter((BmrSlider));

